import React from "react";
import { View, StyleSheet, ActivityIndicator } from "react-native";
import { TTemplateInfo } from "../../../../../utils/types";
import TemplateList from "./TemplateList";
import { NormalText, PrimaryButton } from "../../../../common/native";

type Step2Props = {
  loading: boolean;
  error: string | null;
  templatesInfo: TTemplateInfo[];
  selectedTemplateIndex: number | null;
  setStep: (step: number) => void;
  handleSelectTemplate: (index: number) => void;
};

const Step2: React.FC<Step2Props> = ({
  error,
  loading,
  templatesInfo,
  selectedTemplateIndex,
  setStep,
  handleSelectTemplate,
}) => {
  if (loading) {
    return (
      <ActivityIndicator
        size="large"
        color="#00b7f4"
        style={{ marginHorizontal: "auto", marginTop: 50 }}
      />
    );
  }

  if (error) {
    return <NormalText text={error} style={{ color: "red" }} />;
  }

  return (
    <View style={styles.container}>
      <TemplateList
        templatesInfo={templatesInfo}
        selectedTemplateIndex={selectedTemplateIndex}
        handleSelectTemplate={handleSelectTemplate}
        onTemplateDoubleClick={() => setStep(3)}
      />

      <View style={styles.buttonContainer}>
        <PrimaryButton
          text="Continue"
          width={200}
          disabled={selectedTemplateIndex === null}
          onPress={() => setStep(3)}
          roundBorderRadius
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    gap: 15,
    justifyContent: "center",
    alignItems: "center",
  },
  buttonContainer: {
    marginTop: "auto",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 10,
    justifyContent: "center",
  },
});

export default Step2;
